import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";

export function C9({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    console.log(row.error_id, MessageCodes.Compare.CXY02.error_id)
    switch (row.error_id?.trim()) {
        case MessageCodes.Compare.CXY02.error_id: {
            return (
                <>
                    {
                        row.data.map(x => {
                            return (
                                <ResultText>
                                    There is a difference in the Schematic X, Y table of the stream centerline between RS {<ComparisonCSName csName={x.ds_cross_section} />} and RS {<ComparisonCSName csName={x.us_cross_section} />}. That results in {x.diff} ft. difference in the stream length between the {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plans.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}